import { defineMessages } from "react-intl";

export const scope = "pages.Balance.Investment.Form";

export const messages = defineMessages({
  firstTitle: {
    id: `${scope}.firstTitle`,
    defaultMessage: "Tu cuenta de dólares {br} ¡en EEUU!",
  },
  firstMessage: {
    id: `${scope}.firstMessage`,
    defaultMessage:
      "Recibí transferencias internacionales ACH o Wire y disponé de Pesos o Dólares en Argentina al instante.",
  },
  secondTitle: {
    id: `${scope}.secondTitle`,
    defaultMessage: "¡Activala ahora mismo!",
  },
  secondInfoMessage: {
    id: `${scope}.secondInfoMessage`,
    defaultMessage:
      'Al presionar "Continuar" nos habilitás a que realicemos el cobro para la apertura de tu cuenta',
  },
  thirthTitle: {
    id: `${scope}.thirthTitle`,
    defaultMessage: "Aceptá los términos y condiciones de nuestro partner",
  },
  fourthTitle: {
    id: `${scope}.fourthTitle`,
    defaultMessage: "Estamos creando tu cuenta",
  },
  fourthMessage: {
    id: `${scope}.fourthMessage`,
    defaultMessage:
      "Te notificaremos cuando tu cuenta en EEUU esté operativa y pueda recibir dólares.",
  },
  fourthMessageBold: {
    id: `${scope}.fourthMessageBold`,
    defaultMessage:
      "Este proceso suele tardar al menos un día hábil de Estados Unidos.",
  },
  inAccount: {
    id: `${scope}.inAccount`,
    defaultMessage: "En cuenta",
  },
  start: {
    id: `${scope}.start`,
    defaultMessage: "Comenzar",
  },
  goHome: {
    id: `${scope}.goHome`,
    defaultMessage: "IR AL INICIO",
  },
  notificationErrorTitle: {
    id: `${scope}.notificationErrorTitle`,
    defaultMessage: "Activar cuenta",
  },
  notificationInsufficientFundsErrorSubtitle: {
    id: `${scope}.notificationInsufficientFundsErrorSubtitle`,
    defaultMessage: "No tienes balance suficiente para activar la cuenta.",
  },
  notificationGenericErrorSubtitle: {
    id: `${scope}.notificationGenericErrorSubtitle`,
    defaultMessage:
      "Ocurrió un error al activar la cuenta. Contactate con el soporte.",
  },
});
